import axios from 'axios'
import { AI_SCANNER } from '@/utils'

export type ScanRow = {
    omfang?: number | string | null
    kode?: string | null
    fag?: string | null
    standpunkt?: string | null
    eks_karakter?: string | null
    eks_form?: string | null
    aar?: string | null
    merknad?: string | null
}

export type ScanResponse = {
    rows: ScanRow[]
    courses: Record<string, ScanRow>
    used_pipeline?: string | null
    warnings?: string[]
}

export async function scanTranscriptImage(file: File) {
    const form = new FormData()
    form.append('file', file)

    const { data } = await axios.post<ScanResponse>(
        AI_SCANNER('/extract?mode=auto'),
        form,
        {
            headers: { 'Content-Type': 'multipart/form-data' },
        }
    )

    return data
}